import React from 'react';
import clsx from "clsx";

import './BuyButton.scss';

type Props = {
    className?: string;
    url?: string;
};

const BuyButton: React.FC<Props> = ({className, url}) => {
    
    const links = [
        'https://www.detmir.ru/product/index/id/6252030/',
        'https://www.detmir.ru/product/index/id/6251039/',
        'https://www.ozon.ru/product/panda-fraydi-858618718/?asb=lmzITGtUjgel%252FEjt%252B%252BEYJXfrGKQsx76%252BZKUb60mDLaA%253D&asb2=U_FAcMk42SvsKc9YhN8yK7QHKABKTeqRq2Q9p7VTiu_bVNqJvLFT3oijAEzV5MiI&avtc=1&avte=2&avts=1689844339&keywords=%D0%BF%D0%B0%D0%BD%D0%B4%D0%B0+%D1%84%D1%80%D0%B0%D0%B9%D0%B4%D0%B8+%D0%B8%D0%B3%D1%80%D1%83%D1%88%D0%BA%D0%B0&sh=QX9GmPdGjw',
        'https://www.ozon.ru/product/panda-fraydi-s-aksessuarami-858618722/?asb=s5Nx9UWpLbAe8TzJpEW3YSm3R4KVg8EtAVmmul%252FE58c%253D&asb2=3KW3lP1lbjRHd_xwZUECcHYvtxUxh-KEWKNzSYvmYJhFK9rm8yhfCdT4OARqvlau&avtc=1&avte=2&avts=1689844381&keywords=%D0%BF%D0%B0%D0%BD%D0%B4%D0%B0+%D1%84%D1%80%D0%B0%D0%B9%D0%B4%D0%B8+%D0%B8%D0%B3%D1%80%D1%83%D1%88%D0%BA%D0%B0&sh=QX9GmIge_Q',
        'https://sbermegamarket.ru/catalog/details/myagkie-igrushki-tv-pyatnica-chernyy-600011565550/',
        'https://store.friday.ru/catalog/tags/panda-friday/',
        'https://www.bookvoed.ru/book?id=13609732&utm_source=friday.ru&utm_medium=partners&utm_campaign=panda_friday',
        'https://www.chitai-gorod.ru/product/myagkaya-igrushka-panda-fraydi-35-sm-2978936?utm_source=+landing&utm_medium=social&utm_campaign=+Friday',
        'https://www.wildberries.ru/catalog/145208198/detail.aspx',
        'https://av.ru/search/?text=панда%20Фрайди',
    ];

    const link = url ?? links[Math.floor(Math.random() * links.length)];

    return (
        <a className={clsx('buy-button', className)} href={link} target="_blank" rel="noreferrer">
            Купить игрушку
        </a>
    );
};

export default BuyButton;